(function($) {

	'use strict';

	var init = function() {
		
		var sliderItem = $('.flex-slider__item')

		if(sliderItem.length >= 4) {
			$('.flex-slider__carousel').removeClass('noCarousel')
			$('.flex-slider__carousel').addClass('owl-carousel')
			initCarousel()
		}

		initFlexibleRealisationCarousel()

		initFlexSliderVideo()
	};

	var initCarousel = function() {
		$('.flex-slider__carousel').owlCarousel({
			loop: false,
			autoWidth: true,
			center: true,
			margin: 30,
			nav: false,
			dots: false,
			items: 1,
			responsive: {
				768 : {
					items: 3,
					margin: 70,
				},
				992: {
					center: false,
					items: 4,
					margin: 70,
					nav: true
				}
			}
		})
	}

	var initFlexibleRealisationCarousel = function() {

		$('.slider__container').owlCarousel({
			loop: false,
			autoHeight:false,
			center: true,
			margin: 0,
			nav: true,
			dots: false,
			items: 1
		})
		
	}

	var initFlexSliderVideo = function() {
		var owl = $('.flex-slider_video .slider__container').owlCarousel({
			items: 1,
			video: true,
			lazyLoad: true
		})
	}
  
	$(document).ready(function() {
		init(); 
	});

})(jQuery);
